import OP3Dialog from "../General/Dialog";
import OP3Form from "../General/Form";

class OPDIntegrations {
    constructor() {
        /**
         * Button that triggers all functionality
         *
         * @type {jQuery}
         */
        this.addNewServiceIntegrationBtn = null;

        /**
         * Service jquery-confirm dialog
         *
         * @type {$.confirm}
         */
        this.addNewServiceIntegrationConfirm = null;

        this['jQueryInit']();
    }

    /**
     * jQuery initialization
     */
    ['jQueryInit']() {
        let _this = this;

        (function ($) {

            $(document).ready(() => {
                _this.addNewServiceIntegrationBtn = $('.opd-addNewServiceIntegrationBtn');

                _this['appInit']($);
            });

        })(jQuery);
    }

    /**
     * Functionality after $ is ready
     *
     * @param {jQuery} $
     */
    ['appInit']($) {
        let _this = this;

        _this['addNewServiceIntegration']($);
    }

    /**
     * Opening Dialog once user wants to add new integration
     *
     * @param {jQuery} $
     */
    ['addNewServiceIntegration']($) {
        let _this = this;

        _this.addNewServiceIntegrationBtn
            .click((e) => {
                e.preventDefault();

                let confirmTitle = _this.addNewServiceIntegrationBtn.data('title');

                _this.addNewServiceIntegrationConfirm = $.dialog(Object.assign(OP3Dialog.dialogOptions, {
                    title: OP3Dialog.headerWithFilter(confirmTitle),
                    content: () => {
                        return $.post(
                            op3general.ajax_url,
                            {
                                'action': 'opd_addIntegration',
                            },
                            (response) => {
                                _this.addNewServiceIntegrationConfirm.setContent(response);
                            }
                        )
                    },
                    onContentReady: () => {
                        _this['filterContent']($, '.op3-input-filter', '.opd-dashboard-integrations-list-item', 'h4');
                        _this['openEnterCredentials']($);
                    }
                }));
            })
        ;
    }

    /**
     * Filtering content based on input, search element and search string
     *
     * @param {jQuery} $
     * @param {string} input
     * @param {string} searchHaystack
     * @param {string} searchNeedle
     */
    ['filterContent']($, input, searchHaystack, searchNeedle) {
        let _this = this;

        let $jconfirmTitle = $('.jconfirm-title');
        let $jconfirmContent = $('.jconfirm-content');

        $jconfirmTitle.find(input)
            .keyup((e) => {
                let $input = $(e.currentTarget);
                let searchText = String($input.val()).toLocaleLowerCase();
                $jconfirmContent.find(searchHaystack).each((index, element) => {
                    let $element = $(element);
                    let elementText = String($element.find(searchNeedle).html()).toLocaleLowerCase();

                    (elementText.indexOf(searchText) !== -1) ? $element.removeClass('opd-hide') : $element.addClass('opd-hide');
                });
            })
        ;
    }

    /**
     * Open form for editing credentials and add actions
     *
     * @param {jQuery} $
     */
    ['openEnterCredentials']($) {
        let _this = this;
        let $integrationEnterCredentialsBtn = $('.opd-integration-enter-credentials-btn');
        $integrationEnterCredentialsBtn
            .click((e) => {
                e.preventDefault();

                let $this = $(e.currentTarget);
                let $listItem = $this.closest('.opd-dashboard-integrations-list-item');

                $listItem.addClass('opd-open');

                _this['submitEnterCredentials']($);
            })
        ;
    }

    /**
     * Submit form
     *
     * @param {jQuery} $
     * @todo - Add action url and calls to AJAX for saving integrations
     */
    ['submitEnterCredentials']($) {
        let $integrationEnterCredentialsFormSubmitBan = $('.opd-itegration-enter-credentials-form-submit-btn');
        $integrationEnterCredentialsFormSubmitBan
            .click((e) => {
                e.preventDefault();

                let $this = $(e.currentTarget);
                let $integrationEnterCredentialsForm = $this.closest('.opd-itegration-enter-credentials-form');

                let url = $integrationEnterCredentialsForm.data("action-url");
                let data = $integrationEnterCredentialsForm.find('input').serialize();

                let formObject = new OP3Form($);
                formObject.on('OP3Form:postRequest', (result, $form, url, data) => {
                    console.log(result);
                    if (result.success) {

                    }
                });
                formObject.postRequest($integrationEnterCredentialsForm, url, data);
            })
        ;
    }

}

export default OPDIntegrations;



// WEBPACK FOOTER //
// ./resources/assets/js/Pages/Integrations.js